import { CustomerType } from "@origin-digital/platform-enums";

import { getMcAppFromBaseProps } from "../lib/baseProps";
import { IBaseProps, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const createConcessionsMcApp = ({
  name,
  ...props
}: IBaseProps): IMcAppType[] => {
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_SAP`,
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_DIGISHIFT`,
      digishiftPath: "/manage/concessions",
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/concessions",
      intent: name,
    }),
  ];
};

const concessionsApps: IBaseProps[] = [
  {
    name: "concessions",
    path: "/my-account/concessions/:view?",
    subPath: "",
    description: "View Concessions",
    navFlow: NavFlow.FOCUS,
    title: "Concessions",
    parent: Tab.MORE,
  },
];

const concessions_KRAKEN: IMcAppType = {
  ...concessionsApps[0],
  name: "concessions_KRAKEN",
  path: "/my/concessions",
  navFlow: NavFlow.STANDARD,
  description: "Add or edit concessions",
  conditions: {
    intent: "concessions",
    customerType: CustomerType.kraken,
  },
};

export const concessions: IMcAppType[] = [
  ...concessionsApps.flatMap((app) => createConcessionsMcApp(app)),
  concessions_KRAKEN,
];
